var _preventedKeys;

import * as keyCodes from '../../key-codes';

var preventedKeys = (_preventedKeys = {}, _preventedKeys[keyCodes.enter] = true, _preventedKeys[keyCodes.tab] = true, _preventedKeys);

export default (function (event) {
  if (preventedKeys[event.keyCode]) {
    event.preventDefault();
  }
});


//////////////////
// WEBPACK FOOTER
// ./node_modules/react-beautiful-dnd/esm/view/drag-handle/util/prevent-standard-key-events.js
// module id = 229
// module chunks = 0